import * as types from '../constants/actionTypes';

// Role Actions
export const fetchRbacRoles = (params) => ({
  type: types.FETCH_RBAC_ROLES_REQUEST,
  payload: params
});

export const getRbacRole = (id) => ({
  type: types.GET_RBAC_ROLE_REQUEST,
  payload: id
});

export const createRbacRole = (roleData) => ({
  type: types.CREATE_RBAC_ROLE_REQUEST,
  payload: roleData
});

export const updateRbacRole = (id, roleData) => ({
  type: types.UPDATE_RBAC_ROLE_REQUEST,
  payload: { id, roleData }
});

export const deleteRbacRole = (id) => ({
  type: types.DELETE_RBAC_ROLE_REQUEST,
  payload: id
});

export const fetchRoleUsers = (roleId) => ({
  type: types.FETCH_ROLE_USERS_REQUEST,
  payload: roleId
});

// Action Actions
export const fetchRbacActions = (params) => ({
  type: types.FETCH_RBAC_ACTIONS_REQUEST,
  payload: params
});

export const fetchActionsGrouped = () => ({
  type: types.FETCH_ACTIONS_GROUPED_REQUEST
});

export const createRbacAction = (actionData) => ({
  type: types.CREATE_RBAC_ACTION_REQUEST,
  payload: actionData
});

export const updateRbacAction = (id, actionData) => ({
  type: types.UPDATE_RBAC_ACTION_REQUEST,
  payload: { id, actionData }
});

export const deleteRbacAction = (id) => ({
  type: types.DELETE_RBAC_ACTION_REQUEST,
  payload: id
});

// Permission Actions
export const fetchRolePermissions = (roleId) => ({
  type: types.FETCH_ROLE_PERMISSIONS_REQUEST,
  payload: roleId
});

export const bulkAssignPermissions = (data) => ({
  type: types.BULK_ASSIGN_PERMISSIONS_REQUEST,
  payload: data
});

export const togglePermission = (data) => ({
  type: types.TOGGLE_PERMISSION_REQUEST,
  payload: data
});

// User Actions
export const fetchRbacUsers = () => ({
  type: types.FETCH_RBAC_USERS_REQUEST
});

export const getRbacUser = (id) => ({
  type: types.GET_RBAC_USER_REQUEST,
  payload: id
});

export const updateUserRole = (userId, roleId) => ({
  type: types.UPDATE_USER_ROLE_REQUEST,
  payload: { userId, roleId }
});

export const removeUserRole = (userId) => ({
  type: types.REMOVE_USER_ROLE_REQUEST,
  payload: userId
});

// UI State Actions
export const setRbacEditing = (data) => ({
  type: types.SET_RBAC_EDITING,
  payload: data
});

export const clearRbacEditing = () => ({
  type: types.CLEAR_RBAC_EDITING
});
